<form class="edit-form" (submit)="onSubmit($event)">
  <div class="edit-content">
    <div class="edit-contact-details">
      {{ employee()?.email }}
    </div>
    <div class="edit-role-details">
      <ui-form-selection-list
        appearance="flat"
        [data]="rolesData()"
        [formControl]="rolesControl"
      ></ui-form-selection-list>
    </div>
  </div>
  <div class="edit-footer">
    <ui-button type="submit">Speichern</ui-button>
    <ui-button buttonStyle="text" type="button" (clicked)="onCancel()">Abbrechen</ui-button>
  </div>
</form>
